<template>
  <!-- POC Cuidados Paliativos: cartões de pedido de apoio para a equipe matricial (role 2).
       Reaproveita o visual dos cartões de "Alerta de Sintomas" (diagnosticCard.css). -->
  <div class="diagnostic-card matrix-request-card">
    <div
      v-for="request in dataList"
      :key="request.id"
      class="card"
    >
      <router-link
        :to="{ name: 'myPatientMatrixRequest', params: { id: request.patientId } }"
      >
        <div class="box">
          <article class="media">
            <div class="media-left">
              <figure class="image is-64x64">
                <div class="is-profile-picture-64x64">
                  <img
                    class="is-rounded"
                    :src="photo(request)"
                    alt=""
                    @error="onPhotoError(request)"
                  >
                </div>
              </figure>
            </div>

            <div class="media-content">
              <div class="content">
                <div class="content-line">
                  <div class="patient">
                    {{ patientName(request) }}
                  </div>
                  <span
                    class="matrix-request-status"
                    :class="statusClass(request.status)"
                  >{{ request.status }}</span>
                </div>

                <div class="content-line">
                  <div class="diagnostic matrix-request-reason">
                    {{ reasonLabel(request.reason) }}
                  </div>
                  <div class="date">
                    <span>{{ formatDate(request.createdAt) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { REASON_OPTIONS, statusClass } from "@/services/palliative/matrixSupportApi";

const NEUTRAL_AVATAR = require("@/assets/images/default_avatar_neutral.png");

export default {
  name: "MatrixRequestCard",
  props: {
    dataList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      brokenPhotos: {}
    };
  },
  methods: {
    statusClass,
    // Nome, foto e gênero do paciente vêm no próprio pedido (API).
    patientName(request) {
      return request.patientName || "Nome indisponível";
    },
    onPhotoError(request) {
      this.brokenPhotos = { ...this.brokenPhotos, [request.id]: true };
    },
    reasonLabel(id) {
      const option = REASON_OPTIONS.find((o) => o._id === id);
      return option ? option.name : id;
    },
    formatDate(iso) {
      return this.$moment(iso).format("DD/MM/YYYY - HH:mm");
    },
    // Foto do paciente; sem foto, o avatar padrão por gênero; se nada servir
    // (ou a imagem falhar), o avatar neutro.
    photo(request) {
      if (this.brokenPhotos[request.id]) return NEUTRAL_AVATAR;
      return (
        request.patientPhoto ||
        this.$Utilities.getDefaultProfilePicture(request.patientGender) ||
        NEUTRAL_AVATAR
      );
    }
  }
};
</script>

<style>
@import "~@assets/css/components/diagnosticCard.css";

.matrix-request-card .matrix-request-reason {
  color: #4f3f82;
}

.matrix-request-card .matrix-request-reason:before {
  background-color: #4f3f82;
}

.matrix-request-card .matrix-request-status {
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  color: #4f3f82;
  background-color: #ece9f5;
  white-space: nowrap;
}

.matrix-request-card .matrix-request-status.is-discussing {
  color: #8a5a00;
  background-color: #fff3d6;
}

.matrix-request-card .matrix-request-status.is-answered {
  color: #1e6b3a;
  background-color: #e3f4e8;
}
</style>
